<template>
  <lwf-table
    v-bind="config"
    :loading="loading"
    :columns="vColumns"
    :data="data"
    :pagination.sync="config.pagination"
    selection="multiple"
    row-key="id"
    :selected.sync="selection"
    v-on="$listeners"
    @request="onRequest"
  >
    <template #body-cell-name="props">
      <lwf-td-multiline
        :props="props"
        :actions="actions"
        avatar
        :avatar-picture="props.row.logo"
      />
    </template>
    <template #body-cell-event="props">
      <q-td :props="props">
        <lwf-badge
          v-bind="getEventBadge(props.value)"
          class="block"
        />
      </q-td>
    </template>
    <template
      v-for="(slot, k) in $slots"
      #[k]
    >
      <slot :name="k" />
    </template>
    <template
      v-for="(slot, k) in $scopedSlots"
      #[k]="props"
    >
      <slot
        :name="k"
        v-bind="props"
      />
    </template>
  </lwf-table>
</template>

<script>
import LwfTable from 'components/core/LwfTable/LwfTable'
import LwfTdMultiline from 'components/core/LwfTable/LwfTdMultiline'
import LwfBadge from 'components/core/LwfBadge'
import { DATA_TRACKING_EMAIL_EVENTS, DATA_TRACKING_EMAIL_INDEXED_COLUMNS } from '@/consts/data/trackingEmails'
import tableMixin from 'components/Table/tableMixin'
import { fetchAgencyEmailsEvents } from '@/utils/api/agency/emails'
import { INDETERMINATE_STATUS } from '@/consts/app'

export default {
  name: 'TableTrackingEmails',
  components: { LwfBadge, LwfTdMultiline, LwfTable },
  mixins: [tableMixin],
  INDEXED_COLUMNS: DATA_TRACKING_EMAIL_INDEXED_COLUMNS,
  computed: {
    vColumns () {
      return this.columns
    },
    indexedEvents () {
      return _.keyBy(DATA_TRACKING_EMAIL_EVENTS, 'value')
    }
  },
  methods: {
    getEventBadge (v) {
      return this.indexedEvents[v] || INDETERMINATE_STATUS
    },
    _fetchData () {
      return fetchAgencyEmailsEvents(this.fetchOptions)
    }
  }
}
</script>

<style scoped>

</style>
